/* global axios */
import ApiClient from '../ApiClient';

class AiBotApiRulesAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/api_rules`, { accountScoped: true });
  }

  test(id, { message, variables }) {
    return axios.post(`${this.url}/${id}/test`, { message, variables });
  }
}

export default AiBotApiRulesAPI;
